var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-form__field"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.label),expression:"label"}],staticClass:"v-form__field-label"},[_vm._v(_vm._s(_vm.label))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }